/**
 * @generated SignedSource<<7806bd758fdce9bb524a8f587ad0299c>>
 * @relayHash 0b6977095fa37b117087066acb5850d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3070ae8bfb24f7518a7d946b46b15ba7ac83a8b42b7bccfcb21380c6b4131932

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraJQLBuilderSearchMode = "ADVANCED" | "BASIC" | "%future added value";
export type useSearchModeMutationSearchModeMutation$variables = {
  cloudId: string;
  searchMode?: JiraJQLBuilderSearchMode | null | undefined;
};
export type useSearchModeMutationSearchModeMutation$data = {
  readonly jira: {
    readonly userPreferences: {
      readonly setJQLBuilderSearchMode: {
        readonly errors: ReadonlyArray<{
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly success: boolean;
        readonly userSearchMode: JiraJQLBuilderSearchMode | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSearchModeMutationSearchModeMutation = {
  response: useSearchModeMutationSearchModeMutation$data;
  variables: useSearchModeMutationSearchModeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchMode"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraUserPreferencesMutation",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "searchMode",
                "variableName": "searchMode"
              }
            ],
            "concreteType": "JiraJQLBuilderSearchModeMutationPayload",
            "kind": "LinkedField",
            "name": "setJQLBuilderSearchMode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "success"
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "userSearchMode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSearchModeMutationSearchModeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSearchModeMutationSearchModeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3070ae8bfb24f7518a7d946b46b15ba7ac83a8b42b7bccfcb21380c6b4131932",
    "metadata": {},
    "name": "useSearchModeMutationSearchModeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f83b3554426fd50c234161216030d774";

export default node;
